import React from "react";
import { NavLink } from "react-router-dom";

import styled from "styled-components";
const ContainerMain = styled.div`
  width: 100%;
`;
const NavItem = styled.nav``;
const NavItemLink = styled(NavLink)`
  background: none;
  display: block;
  text-align: left;
  padding: 0 0 20px 0;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 500;
  color: black;
`;
function About() {
  return (
    <ContainerMain>
      <NavItem>
        <NavItemLink activeStyle={{ color: "#DA340E" }} to="/about">
          About
        </NavItemLink>
      </NavItem>
      <NavItem>
        <NavItemLink activeStyle={{ color: "#DA340E" }} to="/faq">
          FAQ
        </NavItemLink>
      </NavItem>
      <NavItem>
        <NavItemLink activeStyle={{ color: "#DA340E" }} to="/privacy">
          Privacy and Data Security Policy
        </NavItemLink>
      </NavItem>

      <NavItem>
        <NavItemLink activeStyle={{ color: "#DA340E" }} to="/customer-terms">
          Terms of Service for Customers
        </NavItemLink>
      </NavItem>
      <NavItem>
        <NavItemLink activeStyle={{ color: "#DA340E" }} to="/shop-terms">
          Terms of Service for Shops
        </NavItemLink>
      </NavItem>
    </ContainerMain>
  );
}

export default About;
